// src/utils/constants.js

/**
 * Centralized constants and configuration
 * Environment-based API URLs
 */

// Get environment variables (supports both CRA and Vite)
// eslint-disable-next-line no-unused-vars
const ENV = typeof import.meta !== 'undefined' ? import.meta.env : process.env;

// Set to empty string for relative URLs via local proxy
export const API_BASE_URL = '';

// API Endpoints
export const API_ENDPOINTS = {
    // Auth
    LOGIN: '/api/method/login',
    LOGOUT: '/api/method/logout',
    WHOAMI: '/api/method/frappe.auth.get_logged_user',

    // Borrower Portal
    BORROWER_SIGNIN: `${API_BASE_URL}/api/method/dynesourcerapi.api.borrower_signin`,
    BORROWER_PROFILE: `${API_BASE_URL}/api/method/dynesourcerapi.api`,
    SHORTLISTED: `${API_BASE_URL}/api/method`,

    // Lender Portal
    PERFORMANCE_METRICS: `${API_BASE_URL}/api/method/dynesourcerapi.api`,
    MORTGAGE_SUMMARY: `${API_BASE_URL}/api/method/dynesourcerapi.api.get_mortgage_product_summary`,
    PRODUCT_SUMMARY: `${API_BASE_URL}/api/method/dynesourcerapi.api.get_product_summary`,
    INVOICE_FINANCE_SUMMARY: `${API_BASE_URL}/api/method/dynesourcerapi.api.get_product_summary`,

    // Sourcing
    MORTGAGE_CALCULATION: `${API_BASE_URL}/api/method/dynesourcerapi.api.calculate_mortgage`,

    // Click Tracking
    CLICK_TRACKING: `${API_BASE_URL}/api/method/dynesourcerapi.api.track_click`,
};

// Local Storage Keys
export const STORAGE_KEYS = {
    AUTH_TOKEN: 'AUTH_TOKEN',
    API_KEY: 'API_KEY',
    API_SECRET: 'API_SECRET',
    CSRF_TOKEN: 'CSRF_TOKEN',
    IS_AUTHED: 'ds_isAuthed',
    PORTAL: 'ds_portal', // 'admin' | 'borrower' | 'lender' – which portal the user is logged into
    LENDER_LOGO: 'lenderLogo',
    BORROWER_EMAIL: 'BORROWER_EMAIL',

    // Shortlist / Sourcing keys
    SHORTLIST: 'ds_shortlist',
    SHORTLIST_PENDING: 'ds_shortlist_pending',
    SHORTLIST_DRAFT_IDS: 'ds_shortlist_draft_ids',
    POST_AUTH_REDIRECT: 'ds_post_auth_redirect',
    SOURCING_CATEGORY: 'ds_sourcing_category',

    // Other
    PENDING_APPLICATIONS: '__ds_pending_applications__',
    APPLICATION_INTENT: '__ds_application_intent__',
    UPLOAD_DOCS: '__ds_upload_docs__',
};

// Session Storage Keys (same as local storage for now)
export const SESSION_KEYS = STORAGE_KEYS;

const constants = {
    API_BASE_URL,
    API_ENDPOINTS,
    STORAGE_KEYS,
    SESSION_KEYS,
};

export default constants;
